package one.healthium.domain.paywall.models


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.Animations


@Serializable
data class Paywall(
    @SerialName("id") val id: String? = null,
    @SerialName("product_android") val productAndroid: String? = null,
    @SerialName("has_skip") val hasSkip: Boolean? = null,
    @SerialName("is_remarketing") val isRemarketing: Boolean? = null,
    @SerialName("skip_alpha") val skipAlpha: Float? = null,
    @SerialName("views") val views: List<PaywallScreenView> = emptyList(),
    @SerialName("config") val config: PaywallConfig? = null,
    @SerialName("product_defaults") val productDefaults: ProductDefaults? = null,
    @SerialName("animations") val animations: Animations? = null,
)